import { LobbyTrendArrow } from "@/components/LobbyOddsItem";

export default function LobbyOddRow({
  leftValue,
  centerValue,
  rightValue,
  leftTrend,
  centerTrend,
  rightTrend,
  leftColor,
  centerColor,
  rightColor,
  isMobile = false,
  empty = false,
}) {
  if (empty) {
    return (
      <div
        className={
          isMobile
            ? "flex h-[22px]"
            : "flex h-7"
        }
      />
    );
  }

  if (isMobile) {
    const defaultLeftColor = "text-[var(--theme-text)]";
    const defaultCenterColor = "kbv-wr-odd-blue";
    const defaultRightColor = "text-[var(--theme-text)]";

    return (
      <div className="flex items-center justify-center h-[22px] w-full">
        <div className="grid grid-cols-[30px_34px_30px] items-center text-[11px] font-bold leading-none gap-0.5 w-fit">
          <div className={`relative flex items-center justify-center w-full ${leftColor || defaultLeftColor}`}>
            <span>{leftValue ?? ""}</span>
            <div className="absolute right-[-2px] flex items-center h-full">
              <LobbyTrendArrow trend={leftTrend} isMobile={true} />
            </div>
          </div>
          <div className={`relative flex items-center justify-center w-full ${centerColor || defaultCenterColor} whitespace-nowrap`}>
            <span>{centerValue ?? ""}</span>
            <div className="absolute right-[-2px] flex items-center h-full">
              <LobbyTrendArrow trend={centerTrend} isMobile={true} />
            </div>
          </div>
          <div className={`relative flex items-center justify-center w-full ${rightColor || defaultRightColor}`}>
            <span>{rightValue ?? ""}</span>
            <div className="absolute right-[-2px] flex items-center h-full">
              <LobbyTrendArrow trend={rightTrend} isMobile={true} />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-7 w-full">
      <div className="grid grid-cols-[40px_42px_40px] items-center gap-0.5 w-fit">
        <div className="kbv-wr-odd-green text-xsm relative flex items-center justify-center font-bold w-full">
          <span>{leftValue ?? ""}</span>
          <div className="absolute right-[-4px] flex items-center h-full">
            <LobbyTrendArrow trend={leftTrend} />
          </div>
        </div>
        <div className="kbv-wr-odd-blue text-xsm relative flex items-center justify-center font-bold whitespace-nowrap w-full">
          <span>{centerValue ?? ""}</span>
          <div className="absolute right-[-4px] flex items-center h-full">
            <LobbyTrendArrow trend={centerTrend} />
          </div>
        </div>
        <div className="kbv-wr-odd-red text-xsm relative flex items-center justify-center font-bold w-full">
          <span>{rightValue ?? ""}</span>
          <div className="absolute right-[-4px] flex items-center h-full">
            <LobbyTrendArrow trend={rightTrend} />
          </div>
        </div>
      </div>
    </div>
  );
}
